import { APR } from '../../APR/APR'
import { Rate } from '../../Rate/Rate'
import Lock from '../../Lock'
import Format from '../../Format'
import usePrev from '../../../../hooks/usePrev'
import { defineMessages, useIntl } from 'react-intl'
import { Flex, Heading, Text } from '@homebotapp/hb-react-component-catalog'
import RefiMessages from '../../RefiModule/RefiByYearsInHome/RefiMessages'
import CountUp from 'react-countup'

export const MSG = defineMessages({
  caution: {
    id: 'Refinance.savings.armLock.caution',
    defaultMessage: 'Saved Over {years} Years'
  },
  bad: {
    id: 'Refinance.savings.armLock.bad',
    defaultMessage: 'Lost Over {years} Years'
  }
})

export interface RefiOptionHeaderProps {
  apr: number
  type: string
  rate: number
  years: number
  locked: boolean
  longterm: number
  caution: boolean
}

export const RefiOptionHeader = ({ apr, rate, type, years, locked, caution, longterm }: RefiOptionHeaderProps) => {
  const intl = useIntl()
  const prevAmt = usePrev(longterm) || undefined

  return (
    <Flex direction='column' flex='1 0 auto' justifyContent='center'>
      <Heading as='h3' size='sm' fontWeight='regular' marginBottom={0}>
        <RefiMessages.LoanName type={type} years={years} />
      </Heading>
      <Flex flex={['0 1 auto', null, '1 1 auto']} align='center' justify='center'>
        <Lock enabled={locked}>
          <Text
            size='lg'
            marginBottom={0}
            fontWeight='light'
            color={longterm <= 0 ? 'danger' : caution ? 'warning' : 'success'}
          >
            <CountUp end={longterm} start={prevAmt} formattingFn={Format.currency} />
          </Text>
          {caution && (
            <Text size='2xs' color={longterm <= 0 ? 'danger' : 'warning'}>
              {intl.formatMessage(longterm > 0 ? MSG.caution : MSG.bad, {
                years
              })}
            </Text>
          )}
        </Lock>
      </Flex>
      <Flex gap={2} justify='center' align='center'>
        {rate != null && <Rate value={rate} />}
        {rate != null && apr !== null && !locked && '•'}
        {apr != null && !locked && <APR value={apr} />}
      </Flex>
    </Flex>
  )
}
